import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';
import { requestHelp } from '../modules/zendesk';

class MemberServices extends Component {

  constructor(props) {
    super();
    this.state = {
      isShowing:       true,
      help: {}
    };
  }

  handleChange( sLabel, sObjectType, event ) {
    let oActiveUpdate       = this.state[ sObjectType ];
    oActiveUpdate[ sLabel ] = event.target.value;
    let oUpdate             = {};
    oUpdate[ sObjectType ]  = oActiveUpdate;
    this.setState( oUpdate );
  }
  sendZendeskRequest( evt ) {
    evt.preventDefault();
    let oState                    = this.state;
    oState.help.club = this.props.tla.toLowerCase() === 'dvd'
      ? 'columbia_house'
      : this.props.tla.toLowerCase();
    this.props.dispatch( requestHelp( oState.help ));
    return false;
  }

  render() {
    return (
      <div className="content-max-width cms">

        <div className="content-max-width">
          <h2>Member Service</h2>
        </div>

        <div id="support-main">

            <div className="content">

              <form onSubmit={this.sendZendeskRequest.bind(this)}>
                <h3>Email Us</h3>
                <input
                  type        = "text"
                  onChange    = {this.handleChange.bind( this, 'customer_name', 'help' )}
                  placeholder = "Your name"
                  value       = {this.state.help.customer_name}
                  required    = "required" />
                <input
                  type        = "email"
                  onChange    = {this.handleChange.bind( this, 'customer_email', 'help' )}
                  placeholder = "Your email"
                  value       = {this.state.help.customer_email}
                  required    = "required" />
                <input
                  type        = "text"
                  onChange    = {this.handleChange.bind( this, 'customer_id', 'help' )}
                  placeholder = "Customer ID (optional)"
                  value       = {this.state.help.customer_id} />
                <input
                  type        = "text"
                  onChange    = {this.handleChange.bind( this, 'order_number', 'help' )}
                  placeholder = "Order Number (optional)"
                  value       = {this.state.help.order_number} />
                <input
                  type        = "text"
                  onChange    = {this.handleChange.bind( this, 'Subject', 'help' )}
                  placeholder = "Subject"
                  value       = {this.state.help.subject} />
                <textarea
                  onChange    = {this.handleChange.bind( this, 'description', 'help' )}
                  placeholder = "Message"
                  value       = {this.state.help.description}
                  required    = "required"  />


                <div className={"select-wrapper unselectable"}>
                  <select
                    onChange     = {this.handleChange.bind( this, 'issue_type', 'help' )}
                    required
                    name="help-issue-type"
                    defaultValue = {this.state.help.issue_type || ""}
                  >
                    <option value="" disabled>Please Select</option>
                    <option value="shipping_questions">Shipping Question</option>
                    <option value="billing_questions">Billing Question</option>
                    <option value="order_status">Order Status</option>
                    <option value="refunds___returns">Refunds &amp; Returns</option>
                    <option value="featured_selections">Featured Selections</option>
                    <option value="cancel_account">Cancel Account</option>
                    <option value="general_questions">General Question</option>
                    <option value="websites_technical_issues">Website/Technical Issues</option>
                  </select>
                </div>

                <div style={{marginTop:'20px'}}>
                  <button className="btn-primary fat">{
                    (() => {
                      if (this.props.zendesk.requesting) {
                        return 'Pending'
                      } else if (this.props.zendesk.success) {
                        return 'Request Submitted'
                      } else {
                        return 'Send Email'
                      }
                    })()
                  }</button>
                </div>
              </form>


          </div>
        </div>

        <div id="support-side">
          <div className="content" >
            <h3>Contact Us</h3>
            TEL: {this.props.member_services_phone}
          </div>
        </div>

      </div>
    );
  }
};

function mapStateToProps(state){
  return {
    'member_services_url': state.store.member_services_url,
    'member_services_phone': state.store.member_services_phone,
    'zendesk': state.zendesk,
    'tla': state.store.tla
  };
}

export default connect(mapStateToProps)(MemberServices);



// WEBPACK FOOTER //
// ./src/components/CmsMemberServices.jsx